import RequestResultsItemWithQueryProvider from "@components_common/components/items/RequestResultsListItem.jsx";

export default RequestResultsItemWithQueryProvider;
